var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOutlinedTimer = function SvgOutlinedTimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E8202C",
    d: "m11.733 10.855-2.4-1.719v-3.5c0-.352-.298-.636-.666-.636S8 5.284 8 5.636v3.819c0 .2.099.389.267.509l2.666 1.909a.7.7 0 0 0 .4.127.67.67 0 0 0 .533-.255.616.616 0 0 0-.133-.89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8202C",
    d: "M9 1C4.589 1 1 4.589 1 9c0 4.412 3.589 8 8 8 4.412 0 8-3.588 8-8 0-4.411-3.588-8-8-8m0 14.76A6.77 6.77 0 0 1 2.24 9 6.77 6.77 0 0 1 9 2.24 6.77 6.77 0 0 1 15.76 9 6.77 6.77 0 0 1 9 15.76"
  })));
};
export default SvgOutlinedTimer;